// Bottom tab bar — Learn / Leagues / Quests / Shop / You.
// Only Learn and You are functional in v1; the rest show a "coming soon"
// state when tapped.

import { Icons } from './Icons.jsx';
import { BALL } from '../theme.js';

const TABS = [
  { id: 'home',    label: 'Learn',   icon: Icons.home },
  { id: 'phrases', label: 'Phrases', icon: Icons.quest },
  { id: 'profile', label: 'You',     icon: Icons.user },
];

export default function BottomTabs({ active = 'home', onSelect, theme = BALL }) {
  return (
    <div style={{
      borderTop: `1px solid ${theme.hairline}`,
      background: theme.bgAlt,
      padding: '8px 4px calc(env(safe-area-inset-bottom) + 8px)',
      display: 'flex', justifyContent: 'space-around',
    }}>
      {TABS.map((tab) => {
        const isActive = tab.id === active;
        const c = isActive ? theme.primary : theme.inkSoft;
        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => onSelect?.(tab.id)}
            style={{
              appearance: 'none', border: 'none', cursor: 'pointer',
              display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2,
              padding: '6px 10px', borderRadius: 10,
              background: isActive ? '#FFF1E6' : 'transparent',
            }}
          >
            {tab.icon(c)}
            <span style={{
              fontSize: 10, fontWeight: 800, color: c, letterSpacing: '0.04em',
            }}>
              {tab.label.toUpperCase()}
            </span>
          </button>
        );
      })}
    </div>
  );
}
